import { motion } from 'framer-motion';

const galleryImages = [
  { src: '/images/img1.jpg', span: 'col-span-1' },
  { src: '/images/img2.jpg', span: 'col-span-1' },
  { src: '/images/img3.jpg', span: 'col-span-1' },
  { src: '/images/img4.jpg', span: 'col-span-1' },
  { src: '/images/img5.jpg', span: 'col-span-1' },
  { src: '/images/img6.jpg', span: 'col-span-1' },
  { src: '/images/img7.jpg', span: 'col-span-1' },
  { src: '/images/img8.jpg', span: 'col-span-1' },
  { src: '/images/img9.jpg', span: 'col-span-1' },
];

const partyImages = [
  { src: '/images/partyimg1.png' },
  { src: '/images/partyimg2.png' },
  { src: '/images/partyimg4.png' },
  { src: '/images/partyimg5.png' },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.5 },
  },
};

const GallerySection = () => {
  return (
    <section className="relative py-24 lg:py-32 bg-[#0a0a0b]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block font-mono text-xs uppercase tracking-widest text-[#ffe03d] mb-4">
            Gallery
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Embrace the
            <span className="text-[#ff965a]"> Adventure</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Experience the thrill of discovering amazing venues and unforgettable moments
          </p>
        </motion.div>

        {/* Party Icons Row */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="flex justify-center gap-6 md:gap-10 mb-16"
        >
          {partyImages.map((img, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.1, rotate: 5 }}
              className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
            >
              <img
                src={img.src}
                alt="Party icon"
                className="w-full h-full object-contain"
              />
            </motion.div>
          ))}
        </motion.div>

        {/* Gallery Grid - App Screenshots in Portrait */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 lg:gap-6"
        >
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className={`relative group overflow-hidden rounded-xl ${image.span}`}
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.3 }}
            >
              {/* Portrait aspect ratio for mobile app screenshots */}
              <div className="aspect-[9/16] overflow-hidden bg-gradient-to-b from-[#ff84e4]/10 to-[#d987ff]/10 rounded-xl p-1">
                <div className="w-full h-full rounded-lg overflow-hidden bg-[#1a1a1b]">
                  <img
                    src={image.src}
                    alt={`App Screenshot ${index + 1}`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default GallerySection;